import { NEDGLOBE_VIEWER, THEME_GROUP_OTHER } from '../../../constants';

export const mutations = {
    ADD_THEME(state, { themeData, active }) {
        const theme = {
            id: themeData.id,
            active,
            data: themeData,
            order: themeData.order + NEDGLOBE_VIEWER.userLayers.themesStartIndex,
            // TODO filters can be removed?
            filters: [],
            themeGroupId: themeData.themeGroupId || THEME_GROUP_OTHER,
            themeLayersDataLoaderPromise: null,
            covering: themeData.covering
        };
        const themes = state.themes.filter(_theme => _theme.id !== theme.id);
        state.themes = [...themes, theme];
    },
    ADD_THEME_LAYERS_LOADER(state, { id, themeLayersDataLoaderPromise }) {
        const themes = state.themes.map(_theme => {
            if (_theme.id === id) {
                return { ..._theme, themeLayersDataLoaderPromise };
            }
            return _theme;
        });
        state.themes = themes;
    },
    SET_THEMEGROUPS(state, themegroups) {
        state.themeGroups = themegroups;
    },
    TOGGLE_THEMEGROUP(state, { groupId, active }) {
        const themeGroup = state.themeGroups.find(({ id }) => id === groupId);
        if (!themeGroup) {
            return;
        }
        const currentState = themeGroup.active;
        themeGroup.active = active ?? !currentState;
    }
};
